import { render, staticRenderFns } from "./ListPageTitle.vue?vue&type=template&id=3f405b3a&scoped=true&"
import script from "./ListPageTitle.vue?vue&type=script&lang=js&"
export * from "./ListPageTitle.vue?vue&type=script&lang=js&"
import style0 from "./ListPageTitle.vue?vue&type=style&index=0&id=3f405b3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f405b3a",
  null
  
)

export default component.exports